export enum EditableTypeDto {
  Text = "Text",
  Number = "Number",
  Select = "Select",
  CheckBox = "CheckBox",
}
